"use client";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface TagsAddInputProps {
  newTagInput: string;
  isLoading: boolean;
  onInputChange: (value: string) => void;
  onKeyPress: (e: React.KeyboardEvent) => void;
  onAdd: () => void;
  onCancel: () => void;
  inputClassName?: string;
  addButtonLabel?: string;
  showCancel?: boolean;
}

export function TagsAddInput({
  newTagInput,
  isLoading,
  onInputChange,
  onKeyPress,
  onAdd,
  onCancel,
  inputClassName = "h-6 px-2 text-xs w-32",
  addButtonLabel = "Add",
  showCancel = true,
}: TagsAddInputProps) {
  return (
    <div className="flex items-center gap-1">
      <Input
        type="text"
        placeholder="Enter tag..."
        value={newTagInput}
        onChange={(e) => onInputChange(e.target.value)}
        onKeyPress={onKeyPress}
        disabled={isLoading}
        className={inputClassName}
        autoFocus
      />
      <Button
        size="sm"
        variant="ghost"
        className="h-6 px-2 text-xs"
        onClick={onAdd}
        disabled={isLoading || !newTagInput.trim()}
      >
        {isLoading ? "..." : addButtonLabel}
      </Button>
      {showCancel && (
        <Button
          size="sm"
          variant="ghost"
          className="h-6 px-2 text-xs"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </Button>
      )}
    </div>
  );
}
